import { render, staticRenderFns } from "./Triggers.vue?vue&type=template&id=4d1c96e2&scoped=true&"
import script from "./Triggers.vue?vue&type=script&lang=js&"
export * from "./Triggers.vue?vue&type=script&lang=js&"
import style0 from "./Triggers.vue?vue&type=style&index=0&id=4d1c96e2&prod&scoped=true&lang=css&"
import style1 from "./Triggers.vue?vue&type=style&index=1&id=4d1c96e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c96e2",
  null
  
)

export default component.exports